// This file is auto-generated by @hey-api/openapi-ts

import type { GetArticlesListResponse } from './types.gen';

const articleListItemSchemaResponseTransformer = (data: any) => {
  data.created_at = new Date(data.created_at);
  data.updated_at = new Date(data.updated_at);
  data.published_at = new Date(data.published_at);
  return data;
};

const articlesListResponseSchemaResponseTransformer = (data: any) => {
  data.results = data.results.map((item: any) => articleListItemSchemaResponseTransformer(item));
  return data;
};

export const getArticlesListResponseTransformer = async (data: any): Promise<GetArticlesListResponse> => {
  data = articlesListResponseSchemaResponseTransformer(data);
  return data;
};
